<template>
  <section class="octobus__section search" :class="{addinionalClass : true}">
    <div :class="{ 'octobus__container': !isFullWidth }">
      <div class="octobus__columns">
          <div class="octobus__column is-paddingless-bottom search-from__wrapper">
            <Autosuggest
              :options="{name: 'city-from', id: 'city-from', class: getClass('from'), placeholder: $t('search.from'), autocomplete: 'off'}"
              :cities="cities"
              :initial-value="from"
              type="from"
              @selected="setAutosuggest"
            />
            <font-awesome-icon
              class="search-from__icon"
              :icon="retweetIcon"
              @click="switchRoutes"
            />
          </div>
          <div class="octobus__column is-paddingless-bottom">
            <Autosuggest
              :options="{name: 'city-to', id: 'city-to', class: getClass('to'), placeholder: $t('search.to'), autocomplete: 'off'}"
              :cities="cities"
              :initial-value="to"
              type="to"
              @selected="setAutosuggest"
            />
          </div>
          <div class="octobus__column">
            <div class="octobus__columns">
              <div class="octobus__column is-paddingless-bottom octobus__datepicker-when">
                <Datepicker
                  id="when"
                  name="when"
                  autocomplete="off"
                  :placeholder="$t('search.when')"
                  :input-class="getClass('when')"
                  :disabled="{to: yesterday}"
                  :language="componentLocale"
                  :monday-first="true"
                  :required="true"
                  @selected="setDatepicker($event, 'when')"
                  v-model="when"
                  calendar-class="datepicker-when"
                  :calendar-button="true"
                  :initial-value="when"
                />
              </div>
              <div class="octobus__column is-hidden-desktop is-paddingless-bottom">
                <div class="octobus__dropdown is-hoverable is-right is-fullwidth-mobile">
                  <div class="octobus__dropdown-trigger is-fullwidth-mobile">
                    <span class="octobus__button people people-mobile is-medium is-fullwidth-mobile" aria-haspopup="true" aria-controls="people">
                      <span>{{ $t('search.passenger') }}</span>
                      <span class="people-mobile-icon">
                        <span class="octobus__icon is-small">
                          <font-awesome-icon :icon="iconUser" />
                        </span>
                        <span>{{passengers}}</span>
                      </span>
                    </span>
                  </div>
                  <div class="octobus__dropdown-menu" id="people" role="menu">
                    <div class="octobus__dropdown-content has-text-left">
                      <div class="octobus__dropdown-item">
                        <div class="select-title">{{$t('search.passenger')}}</div>
                        <Counter
                          :init-count="adult"
                          :min="1"
                          @counterChange="setPassengers"
                          age="adult"
                          :sum="passengers"
                          :can-add-more="validateCount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- For touch -->
          <div class="octobus__column is-hidden-touch">
            <div class="octobus__columns is-mobile">
              <div class="octobus__column is-one-quarter-mobile is-narrow-desktop">
                <div class="octobus__dropdown is-hoverable">
                  <div class="octobus__dropdown-trigger">
                    <button class="octobus__button people is-medium" aria-haspopup="true" aria-controls="people">
                      <span class="octobus__icon is-small">
                        <font-awesome-icon :icon="iconUser" />
                      </span>
                      <span>{{passengers}}</span>
                    </button>
                  </div>
                  <div class="octobus__dropdown-menu" id="people" role="menu">
                    <div class="octobus__dropdown-content">
                      <div class="octobus__dropdown-item">
                        <div class="select-title">{{$t('search.passenger')}}</div>
                        <Counter
                          :init-count="adult"
                          :min="1"
                          @counterChange="setPassengers"
                          age="adult"
                          :sum="passengers"
                          :can-add-more="validateCount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="octobus__column is-three-quarters-mobile">
                <div class="octobus__control">
                  <button
                    class="octobus__button is-primary is-fullwidth is-medium"
                    :disabled="!validate"
                    @click="onClick"
                    :class="{'is-loading': searching}"
                  >{{$t('search.search')}}</button>
                </div>
              </div>
            </div>
          </div>
      </div>
      <!-- For touch -->
      <div class="octobus__columns is-hidden-desktop">
        <div class="octobus__column">
          <Currency @setCurrency="setCurrency" :currencyList="currencyList" customClass="has-text-right" v-show="$searchCurrency" />
        </div>
      </div>
      <div class="octobus__columns is-vcentered">
        <div class="octobus__column is-one-quarter-desktop is-4-tablet is-hidden-touch">
          <div class="field" v-show="showAdditionalSearch">
            <input
              v-model="directPathChecked"
              id="directPath"
              type="checkbox"
              name="directPath"
              class="switch is-thin"
            >
            <label for="directPath">{{$t('search.direct')}}</label>
          </div>
        </div>
        <div class="octobus__column is-hidden-touch">
          <div class="octobus__field" v-show="showAdditionalSearch">
            <input
              v-model="bothSideChecked"
              id="bothSide"
              type="checkbox"
              name="bothSide"
              class="switch is-thin"
            >
            <label for="bothSide">{{$t('search.bothside')}}</label>
          </div>
        </div>
        <div class="octobus__column is-hidden-touch octobus__datepicker-backdate">
          <Datepicker
            id="backdate"
            name="backdate"
            :placeholder="$t('search.backdate')"
            :input-class="getClass('backdate')"
            :disabled="{to: yesterday}"
            :language="componentLocale"
            :monday-first="true"
            :required="true"
            @selected="setDatepicker($event, 'backdate')"
            v-model="backdate"
            calendar-class="datepicker-when"
            v-if="bothSide"
            :calendar-button="true"
          />
        </div>
        <div class="octobus__column is-hidden-touch">
          <Currency @setCurrency="setCurrency" :currencyList="currencyList" v-show="$searchCurrency" />
        </div>
      </div>
      <!-- For touch -->
      <div class="octobus__columns is-hidden-desktop">
        <div class="octobus__column">
          <button
            class="octobus__button is-primary is-fullwidth is-medium"
            :disabled="!validate"
            @click="onClick"
            :class="{'is-loading': searching}"
          >{{$t('search.search')}}</button>
        </div>
      </div>
    </div>
    <NewPassword
      v-if="resetModal"
      :show="resetModal"
      :token="token"
      @hideModal="onHideModal"
    />
  </section>
</template>

<script>
import api from '@/api';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faUser, faRetweet } from '@fortawesome/fontawesome-free-solid';
import Autosuggest from '@/components/Autosuggest/Autosuggest';
import Counter from '@/components/Counter/Counter';
import Currency from '@/components/_common/Currency';
import NewPassword from '@/components/_common/NewPassword';
import { isUrlLang, getComponentLocale } from '@/utils/utils';

export default {
  name: 'Search',
  components: { Autosuggest, Datepicker, Counter, Currency, FontAwesomeIcon, NewPassword },
  props: {
    addinionalClass: {
      type: String,
      default() {
        return '';
      },
    },
    async: {
      type: Boolean,
      default: true,
    },
    initialCities: {
      type: Array,
      default() {
        return [];
      },
    },
    initialFrom: {
      type: Object,
      default() {
        return null;
      },
    },
    initialTo: {
      type: Object,
      default() {
        return null;
      },
    },
    initialWhen: {
      default() {
        return null;
      },
    },
    initialAdult: {
      type: Number,
      default() {
        return 1;
      },
    },
    initialChildren: {
      type: Number,
      default() {
        return 0;
      },
    },
    initialBackDate: {
      default() {
        return null;
      },
    },
    initialIsBack: {
      type: Number,
      default() {
        return 0;
      },
    },
    initialChange: {
      type: [Number, Boolean],
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      cities: this.initialCities,
      from: this.initialFrom,
      to: this.initialTo,
      when: this.initialWhen,
      lang: this.$framelocale,
      yesterday: new Date(moment().subtract(1, 'd')),
      adult: this.initialAdult,
      children: this.initialChildren,
      backdate: this.initialBackDate,
      bothSide: this.$searchBack ? 1 : this.initialIsBack,
      directPath: this.$searchChanges ? 1 : this.initialChange,
      currency: 'UAH',
      currencyList: this.$currencyList,
      searching: false,
      resetModal: false,
      token: '',
      componentLocale: getComponentLocale(this.$framelocale),
    };
  },
  /* eslint-disable object-shorthand */
  watch: {
    '$route.fullPath'() {
      this.when = this.$route.query.when;
    },
    'initialBackDate'(newValue) {
      this.backdate = newValue;
    },
  },
  methods: {
    onHideModal() {
      this.resetModal = false;

      // eslint-disable-next-line no-unused-vars
      const { token: _, queryWithoutToken } = this.$route.query;
      this.$router.replace({ query: queryWithoutToken });
    },
    setAutosuggest(data) {
      const [type, item] = data;
      this[type] = item;

      if (type === 'to') {
        const el = document.querySelector('.octobus__datepicker-when .vdp-datepicker__calendar-button');

        if (el) {
          el.click();
        }
      }
    },
    switchRoutes() {
      const { from, to } = this;

      this.$set(this, 'from', to);
      this.$set(this, 'to', from);
    },
    setDatepicker(newDate, datepicker) {
      this[datepicker] = newDate;
      if (datepicker === 'when' && this.bothSide === true) {
        const el = document.querySelector('.octobus__datepicker-backdate .vdp-datepicker__calendar-button');

        if (el) {
          el.click();
        }
      }
    },
    // getCity(id) {
    //   return this.cities.filter(city => Number(city.id) === Number(id))[0];
    // },
    onClick() {
      if (this.validate) {
        this.searching = true;
        this.redirect();
        this.searching = false;
        return true;
      }

      return false;
    },
    setCurrency(value) {
      this.currency = value;
    },
    getClass() {
      const primary = 'octobus__input is-medium';

      return `${primary} is-primary`;
    },
    isBackDateValid() {
      return this.backdate !== null && moment(this.backdate).isSameOrAfter(this.when);
    },
    redirect() {
      const when = moment(this.when).format('YYYY-MM-DD');
      let searchParams = `?from=${this.from.id}&to=${this.to.id}&when=${when}&adult=${this.adult}&children=${this.children}&currency=${this.currency}`;
      let backdate = null;
      const lang = isUrlLang ? `/${this.$UrlLang}` : '';

      if (this.directPath) {
        searchParams += '&change=1';
      } else {
        searchParams += '&change=0';
      }

      if (this.bothSide && this.backdate) {
        backdate = moment(this.backdate).format('YYYY-MM-DD');
        searchParams += `&goback=1&whenback=${backdate}`;
      }

      // for viabona
      if (this.$search) {
        const data = {
          from: this.from.id,
          to: this.to.id,
          when: when,
          adult: this.adult,
          children: this.children,
          currency: this.currency,
          change: Number(this.directPath),
          ...(this.bothSide && this.backdate) && { backdate: `&goback=1&whenback=${backdate}` },
        };

        this.$emit('search:new', data);
      } else {
        const { children } = this.$router.options.routes[1];
        const route = children.find(r => r.name === 'Result');
        /* eslint-disable */
        if (this.$framespa !== true && (this.$route.name === 'Main' || this.$route.name === 'MainWithRedirect')) {
          if (this.$newTab) {
            window.open(`${lang}/${route.path}${searchParams}`);
          } else {
            location.href = `${lang}/${route.path}${searchParams}`;
          }
        } else if (this.$newTab) {
          let routeData = this.$router.resolve(`${lang}/${route.path}${searchParams}`);
          window.open(routeData.href, '_blank');
        } else {
          this.$router.push(`${lang}/${route.path}${searchParams}`);
        }
      }

      localStorage.setItem('__octobus__search-cnt', this.passengers);
    },
    setPassengers(value, type) {
      this[type] = value;
    },
    setAditionalParam(id, status) {
      if (id === 'bothSide' && this.directPath && status) {
        this.directPath = !this.directPath;
      }

      if (id === 'directPath' && this.bothSide && status) {
        this.bothSide = !this.bothSide;
      }

      this[id] = status;
    },
  },
  computed: {
    validate() {
      if (
        this.when !== null &&
        !(this.bothSide && !this.isBackDateValid()) &&
        (this.from || {}).id &&
        (this.to || {}).id &&
        !!this.currency
      ) {
        return true;
      }

      return false;
    },
    retweetIcon() {
      return faRetweet;
    },
    showAdditionalSearch() {
      return !this.$hideAdditionalSearch;
    },
    passengers() {
      return Number(this.adult) + Number(this.children) || 1;
    },
    validateCount() {
      return this.passengers < 10;
    },
    iconUser() {
      return faUser;
    },
    bothSideChecked: {
      get() {
        return this.bothSide;
      },
      set(newVal) {
        this.setAditionalParam('bothSide', newVal);
      },
    },
    directPathChecked: {
      get() {
        return this.directPath;
      },
      set(newVal) {
        this.setAditionalParam('directPath', newVal);
      },
    },
    isFullWidth() {
      return this.$fullwidth;
    },
  },
  created() {
    if (this.async) {
      api.Content.cities().then((res) => {
        this.cities = res;

        // if (this.$search) {
        //   this.from = this.getCity(this.$search.from);
        //   this.to = this.getCity(this.$search.to);
        // }
      });
    }
  },
  mounted() {
    localStorage.setItem('__octobus__search-cnt', this.passengers);

    const { token } = this.$route.query;

    if (token) {
      this.resetModal = true;
      this.token = token;
    }
  },
};
</script>

<style scope lang="scss">
/* Large Devices, Wide Screens */
@media only screen and (min-width : 768px) {
  #app, #auth {
    .search {
      span.octobus__icon.is-small {
        min-width: 4rem;
      }

      .search-from__wrapper {
        position: relative;
      }

      .search-from__icon {
        position: absolute;
        right: -10px;
        top: 39%;
        cursor: pointer;
      }
    }
  }
}

#app, #auth {
  .search {
    .select-title {
      display: inline-block;
    }

    .fa-minus::before,
    .fa-plus::before {
      display: none !important;
    }

    .vdp-datepicker {
      .vdp-datepicker__calendar-button {
        display: none;
      }

      .vdp-datepicker__calendar {
        margin-top: 10px;
        background-color: white;
        border-radius: 5px;
        color: #4a4a4a;
        display: block;
        padding: 1.25rem;

        .up {
          position: unset;
          height: auto;
        }

        .cell.today {
          border-color: $color-main;
        }

        .cell.selected,
        .cell.selected:hover {
          border-color: $color-main;
          background: $color-main;
          color: #fff;
        }
      }
    }

    .octobus__dropdown {
      .people {
        border-color: #00d1b2;

        &-mobile {
          justify-content: unset;

          &-icon {
            position: absolute;
            right: 15px;
          }
        }
      }
      .octobus__button:focus:not(:active),
      .octobus__button.is-focused:not(:active) {
        box-shadow: none;
      }
    }
  }
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
  #app, #auth {
    .is-fullwidth-mobile {
      width: 100%;
    }

    // .is-medium {
    //   font-size: 1.25rem;
    // }

    // .is-paddingless-bottom {
    //   padding-bottom: 0px;
    // }

    .search-from__wrapper {
      position: relative;
    }

    .search-from__icon {
      position: absolute;
      right: 20px;
      top: 37%;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue